export default "/images/41c74eb554f648bf65a38d126b751eb9.jpg";